export const ROUTE_PATHS = {
  DASHBOARD: '/dashboard',
  USERS: '/users',
  ROLES: '/roles',
  PROFILE: '/profile',
  DEPARTMENT: '/department',
  PERMISSIONS: '/permissions',
  CUSTOMERS_LIST: '/customers/list',
  REQUESTS_LIST: '/requests/list',
  SALES_FRESH_REQUESTS_LIST: '/sales/requests/fresh',
  SALES_ASSIGNED_REQUESTS_LIST: '/sales/requests/assigned',
  SALES_MY_REQUESTS_LIST: '/sales/requests/myRequests/all',
  SALES_WHATSAPP_REQUEST: '/sales/requests/myRequests/follow_up/whatsApp',
  SALES_CALLED_REQUEST: '/sales/requests/myRequests/follow_up/called',
  SALES_INTERSTED_REQUEST: '/sales/requests/myRequests/follow_up/interested',
  SALES_BUSY_REQUEST: '/sales/requests/myRequests/follow_up/line_busy',
  SALES_SUMMARY_REQUEST: '/sales/summaryrequests',
  CALLCENTER_SUMMARY_REQUEST: '/callcenter/summaryrequests',
  SALES_OUT_OF_SERVICE_REQUEST:
    '/sales/requests/myRequests/follow_up/out_of_service',
  SALES_NO_ANSWER_REQUEST: '/sales/requests/myRequests/follow_up/no_answer',
  SALES_CANCELED_REQUEST: '/sales/requests/myRequests/canceled',
  SALES_FOLLOWUP_REQUEST: '/sales/requests/myRequests/follow_up',
  SALES_DONE_REQUEST: '/sales/requests/myRequests/done',
  SALES_CONFIRMED_REQUEST: '/sales/requests/myRequests/confirmed',
  SALES_PAID_PAYMENT_REQUEST: '/sales/requests/myRequests/paidpayment',
  CONFIRMED_REQUESTS_LIST: '/requests/confirmed',
  DONE_REQUESTS_LIST: '/requests/done',
  DONE_REQUEST: '/requests/myRequests/done',
  VIEW_REQUEST: '/request/:id',
  SALES_REQUEST: '/sales/myRequests',
  AUDIT_FRESH_REQUESTS_LIST: '/audit/fresh',
  AUDIT_ASSIGNED_REQUESTS_LIST: '/audit/assigned',
  OPERATION_ASSIGNED_REQUESTS_LIST: '/opertaion/Confirmed',
  HOLIDAAYS: '/holidays',
  SUPPLIERS: '/suppliers',
  RATINGFACTOR: '/ratingFactor',
  CHANGEPASSWORD: '/changePassword',
  NOTIFICATIONS: '/notifications',
  CALL_CENTER_ALLREQUEST: '/callCenter/allRequests',
  ACCOUNTENT_FRESH: '/accountent/fresh',
  ACCOUNTENT_DONE: '/accountent/done',
  ACCOUNTENT_MYREQUESTS: '/accountent/myRequests',
  ACCOUNTENT_ASSIGNED: '/accountent/assigned',
  AUDIT_FRESH: '/audit/fresh',
  AUDIT_MYREQUESTS: '/audit/myRequests',
  OPERATION_CONFIRMED_FRESH: '/operation/confirmed/fresh',
  OPERATION_CONFIRMED_ASSIGNED: '/operation/assigned/confirmed',
  OPERATION_MYREQUSTS: '/operation/myRequests',
    REPORTS_REQUESTS_COUNT: '/reports/requests-count',
    REPORTS_SALES: '/reports/sales',
}
